import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import { gantt } from 'dhtmlx-gantt';
import { SchedularWrapper } from './SchedularWrapper';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { SearchBox, Icon } from "@fluentui/react";
import styled from "styled-components";
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import './gantt.css'
import moment from "moment";

const iconClass = mergeStyles({
    fontSize: 24,
    height: 24,
    width: 24,
    margin: '0 8px',
    cursor: 'pointer',
    '-webkit-tap-highlight-color': 'transparent',
    '-webkit-user-select': 'none',
    '-khtml-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
});
const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 96%;
  margin:0px 0px 0px 4px;
  border: 1px solid black;
  border-radius: 2px;
  .ms-CommandBar {
    padding: 0;
  }
`;
const searchBoxStyles = {
    root: {
        width: "100%",
        height: 32,
        padding: 10,
        border: "none",
        outline: "none",
        "&:hover, &::after": {
            border: "none",
            outline: "none",
        },
    },
};
export default class Gantt extends Component {
    state = {
        search: '',
        data: this.props.tasks,
        isSearchClicked: false,
    }
    handleSearch = (val) => {
        gantt.clearAll();
        if (val) {
            this.setState({ ...this.state, data: { ...{ data: this.props.tasks.data.filter(i => i.title?.toLowerCase().includes(val?.toLowerCase())) } }, search: val, isSearchClicked: true });
            gantt.parse({ data: this.props.tasks.data.filter(i => i.title?.toLowerCase().includes(val?.toLowerCase())) });
        }
        else {
            this.setState({ ...this.state, data: this.props.tasks, search: val, isSearchClicked: false });
            gantt.parse(this.props.tasks)
        }
    }
    componentDidUpdate() {
        if (!this.state.isSearchClicked) {
            gantt.clearAll();
            gantt.parse(this.props.tasks);
        }
    }
    componentDidMount() {
        gantt.clearAll();
        gantt.config.date_format = "%Y-%m-%d %H:%i";
        gantt.config.columns = [
            {
                name: 'text',
                label: "Resource", resize: true, width: '*',
                onrender: (item) => <SchedularWrapper item={item} tasks={this.state.data}></SchedularWrapper>
            }
        ];
        gantt.config.external_render = {
            isElement: (element) => {
                return React.isValidElement(element);
            },
            renderElement: (element, container) => {
                let root = ReactDOM.createRoot(container);
                root.render(element)
            }
        };
        gantt.attachEvent("onTaskClick", function (id, e) {
            return false;
        });
        gantt.attachEvent("onTaskDoubleClick", function (id, e) {
            return false;
        });
        gantt.templates.scale_cell_class = function (date) {
            return "weekend";
        };
        gantt.templates.scale_line_class = function (date) {
            return "weekend";
        };
        var zoomConfig = {
            levels: [
                // hours
                {
                    name: "hour",
                    scale_height: 27,
                    scales: [
                        { unit: "day", step: 1, format: "%d %M" },
                        { unit: "hour", step: 1, format: "%H:%i" },
                    ]
                },

                // weeks
                {
                    name: "week",
                    scale_height: 50,
                    scales: [
                        {
                            unit: "week", step: 1, format: function (date) {
                                var dateToStr = gantt.date.date_to_str("%d %M");
                                var endDate = gantt.date.add(date, 7 - date.getDay(), "day");
                                return dateToStr(date) + " - " + dateToStr(endDate);
                            }
                        },
                        { unit: "day", step: 1, format: "%j %D" }
                    ]
                },
                // months
                {
                    name: "month",
                    scale_height: 50,
                    scales: [
                        { unit: "month", step: 1, format: "%F, %Y" },
                        {
                            unit: "week", step: 1, format: function (date) {
                                var dateToStr = gantt.date.date_to_str("%d %M");
                                var endDate = gantt.date.add(date, 7 - date.getDay(), "day");
                                return dateToStr(date) + " - " + dateToStr(endDate);
                            }
                        }
                    ]
                },
            ],
            element: function () {
                return gantt.$root.querySelector(".gantt_task");
            }
        };
        gantt.plugins({
            tooltip: true
        });
        gantt.config.fit_tasks = true;
        gantt.ext.zoom.init(zoomConfig);
        gantt.ext.zoom.setLevel("hour");
        gantt.$zoomToFit = false;
        gantt.config.readonly = true;
        gantt.config.row_height = 50
        gantt.init(this.ganttContainer);
        gantt.parse(this.state.data);
        gantt.config.show_empty_state = true;
        // gantt.ext.emptyStateElement.getContainer = function () {
        //     return gantt.$task_data.closest(".gantt_layout_content");
        // };
        gantt.ext.emptyStateElement.renderContent = function (container) {
            const placeholderTextElement = `<div class='gantt_empty_state_text'>
            <div class='gantt_empty_state_text_description'>
              No data to display</div>
            </div>`;
            const placeholderImageElement = "<div class='gantt_empty_state_image'></div>";

            const placeholderContainer = `<div class='gantt_empty_state'>
               ${placeholderImageElement}${placeholderTextElement}</div>`;
            container.innerHTML = placeholderContainer;
        }

        gantt.templates.tooltip_text = function (start, end, task) {
            return "<b>Task:</b> " + task.text + "<br/><b>Start Date:</b> " + moment(start).format("YYYY-MM-DD HH:mm:ss") + "<br/><b>End Date:</b> " + moment(end).format("YYYY-MM-DD HH:mm:ss");
        };
        gantt.ext.tooltips.tooltipFor({
            selector: ".gantt_scale_cell",
            html: function (event) {
                return event.target.innerText;
            }
        });
    }
    render() {
        return (
            <>
                <div className='d-flex justify-content-between mt-3 mb-3'>
                    <div style={{ marginBottom: 4 }}>
                        <SearchWrapper>
                            <SearchBox
                                value={this.state.search}
                                styles={searchBoxStyles}
                                placeholder="Search"
                                onChange={(_, newValue) => this.handleSearch(newValue)}
                                onSearch={(newValue) => this.handleSearch(newValue)}
                            />
                        </SearchWrapper>
                    </div>
                    {this.state.isLoading && <div className='absolute-spinner-nav'><Loader /></div>}
                    <div className='d-flex  justify-content-end mb-2'>
                        <Icon
                            iconName={"Blocked2"}
                            className={iconClass}
                            onClick={() => {
                                gantt.ext.zoom.zoomOut();
                                gantt.$zoomToFit = false;
                            }}
                        ></Icon>
                        <div style={{ fontSize: 20, textAlign: 'center', margin: '0 8px', }}>
                            View
                        </div>


                        <Icon
                            iconName={"AddTo"}
                            className={iconClass}
                            onClick={() => {
                                gantt.ext.zoom.zoomIn();
                                gantt.$zoomToFit = false;
                            }}
                        ></Icon>
                    </div>
                </div>
                <div
                    ref={(input) => { this.ganttContainer = input }}
                    style={{ width: '100%', height: '100%' }}
                ></div>
            </>
        );
    }
}